
import { defineComponent } from 'vue'
import { TOOLTIP_COMPONENTS } from '@/composables/post/postTooltip'
import AButton from '@/components/Forms/AButton.vue'
import AIcon from '@/components/AIcon.vue'

export default defineComponent({
  name: TOOLTIP_COMPONENTS.POST_BANNED,
  emits: ['tooltip-close'],
  components: { AIcon, AButton },
  props: {
    alreadyPerformed: {
      type: Boolean,
      default: false,
    },
  },
})
